module.exports = __webpack_public_path__ + "media/images/sport--skisprung-5855128ee9406ac4a8a09ac0b3a1b5f7.png";